<template>
  <div class="min-body">
    <!-- banner -->
    <banner :banner-list="bannerList"></banner>
    <!-- desc -->
    <div class="About-desc-box">
      <div class="About-desc">
        <span>{{ $t('common.companyMission') }}</span>
        <span>{{ $t('about.mission') }}</span>
      </div>
      <div class="About-desc">
        <span>{{ $t('common.companyVision') }}</span>
        <span>{{ $t('about.vision') }}</span>
      </div>
      <div class="About-desc">
        <span>{{ $t('common.companyValues') }}</span>
        <span>{{ $t('about.values') }}</span>
      </div>
    </div>
    <!-- 公司介绍 -->
    <div class="Company-Profile-box">
      <div class="About-title">{{ $t('common.companyIntro') }}</div>
      <div class="Company-Profile-text">
        {{ $t('about.intro') }}
      </div>
      <div class="stats-container">
        <div class="stat-item">
          <div class="stat-number">{{ $t('about.stat1') }}</div>
          <div class="stat-label">{{ $t('common.serviceExp') }}</div>
          <div class="stat-progress">
            <div class="stat-progress-bar"></div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ $t('about.stat2') }}</div>
          <div class="stat-label">{{ $t('common.mineAlgorithm') }}</div>
          <div class="stat-progress">
            <div class="stat-progress-bar"></div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ $t('about.stat3') }}</div>
          <div class="stat-label">{{ $t('common.citiesCovered') }}</div>
          <div class="stat-progress">
            <div class="stat-progress-bar"></div>
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ $t('about.stat4') }}</div>
          <div class="stat-label">{{ $t('common.customerCases') }}</div>
          <div class="stat-progress">
            <div class="stat-progress-bar"></div>
          </div>
        </div>
      </div>


    </div>
    <!-- 团队历程 -->
    <div class="About-box">
      <div class="About-title">{{ $t('common.teamHistory') }}</div>
      <div class="About-main Intellectual">
<!--        <Tdlc style="width: 100%;height: 850px"></Tdlc>-->
        <img src="@/assets/img/About/tdlc.png" style="width: 100%">
      </div>
    </div>
    <!-- 认证体系 -->
    <div class="About-box">
      <div class="About-title">{{ $t('common.certSystem') }}</div>
      <div class="About-main Certification">
        <img src="@/assets/img/About/renz.webp">
        <img src="@/assets/img/About/renz1.webp">
        <img src="@/assets/img/About/renz2.webp">
      </div>
    </div>
    <!-- 知识产权 -->
    <div class="About-box">
      <div class="About-title">{{ $t('common.ipRights') }}</div>
      <div class="About-main Intellectual">
        <img src="@/assets/img/About/zscq.jpg">
      </div>
    </div>
    <!-- Footer -->
    <Footer style="margin-top: 100px"></Footer>
    <!--END!-->
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import banner from "@/views/Home/components/Banner/banner.vue";
// import Tdlc from "@/views/About/components/Tdlc.vue";
export default {
  name: "index",
  components:{
    banner,
    Footer,
    // Tdlc
  },
  data(){
    return {
      bannerList: [
        {
          titleKey: 'about.banner.title',
          descKey: 'about.banner.desc',
          btnText: '',
          image: require('@/assets/img/About/banner/about-banner01.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.aiEngine.tags'
        }
      ]
    }
  },
  mounted() {
    window.scrollTo(0,0);
  }
}
</script>

<style scoped lang="less">
.Algorithm-main{
  width: 100%;
}
.subTitle{
  font-size: 36px;
  font-weight: 600;
  color: #191E4C;
  line-height: 50px;
  padding: 40px 0;
}
.subCol{
  font-size: 16px;
  color: #191E4C;
  line-height: 29px;
  margin-bottom: 40px;
}
.About-desc-box{
  width: calc(100% - 26vh);
  height: 9vh;
  margin: 12vh auto;
  display: flex;
  justify-content: space-between;
  .About-desc{
    span{
      display: block;
      &:nth-of-type(1) {
        color: #262626;
        font-size: 2vw;
        font-weight: bold;
      }
      &:nth-of-type(2) {
        color: #595959;
        font-size: 1vw;
      }
    }
  }
}
.About-box{
  width: 100%;
  min-height: 30vh;
  .About-main{
    width: calc(100% - 60vh);
    margin: 0 auto;
    &.Certification{
      display: flex;
      justify-content: space-between;
      >img{
        width: calc((100% - 12vh) / 3);
      }
    }
    &.Intellectual{
      >img{
        width: 100%;
      }
    }
  }
}
.Company-Profile-box{
  width: 100%;
  min-height: 30vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  &::after{
    width: 100%;
    height: 34vh;
    content: "";
    position: absolute;
    z-index: 0;
    top:0;
    left:0;
    background: url("~@/assets/img/About/Company-Profile-bg.webp") no-repeat center top;
  }
  .Company-Profile-text{
    z-index: 1;
    width: calc(100% - 26vh);
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    padding: 5vh;
    font-family: PingFang SC, PingFang SC;
    font-size: 1.2vw;
    color: #262626;
    line-height: 58px;
  }
}

.stats-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 80vw;
  padding: 4rem 2rem;
  background-color: #ffffff;
  .stat-item {
    text-align: center;
    flex: 1;
    position: relative;
  }
  .stat-number {
    font-size: 3vw;
    font-weight: bold;
    color: #0052ff;
    margin-bottom: 1.5vh;
    line-height: 1;
  }
  .stat-label {
    font-size: 1.5vw;
    color: #666666;
    margin-bottom: 2vh;
  }
  .stat-progress {
    width: 100%;
    height: 8px;
    background-color: #f0f7ff;
    border-radius: 4px;
    overflow: hidden;
  }
  .stat-progress-bar {
    height: 100%;
    background-color: #0052ff;
    border-radius: 4px;
    width: 15%;
    margin: 0 auto;
  }
}

.About-title{
  width: 100%;
  color: #262626;
  font-size: 2vw;
  font-weight: bold;
  margin: 8vh auto 5vh auto;
  text-align: center;
  z-index: 1;
}
</style>